export default "__VITE_ASSET__Bt_q4HfL__"